import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5e5cbe6c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=5e5cbe6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5cbe6c",
  null
  
)

export default component.exports